var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { Button } from '../../../styles';
import { CheckIcon } from '../../icons/Check';
import { Container, LinkButtonContainer, ContentContainer, CheckIconContainer, } from './styles';
export var SuccessModalContent = function (_a) {
    var _b;
    var section = _a.section, onLinkClick = _a.onLinkClick, contextProps = _a.contextProps;
    var theme = useTheme();
    return (_jsx(Container, { children: _jsxs(ContentContainer, __assign({ "$color": theme.primary }, { children: [!section.successRedirectLink && (_jsx(CheckIconContainer, __assign({ "$bgColor": theme.primary }, { children: _jsx(CheckIcon, { color: theme.secondary }, void 0) }), void 0)), _jsx("h4", { children: ((_b = section.successMessage) === null || _b === void 0 ? void 0 : _b.trim()) ||
                        contextProps.form.defaultSuccessMessage }, void 0), section.successRedirectLink && (_jsx(LinkButtonContainer, { children: _jsx(Button, __assign({ textColor: theme.textButtons, backgroundColor: theme.buttons, onClick: function () { return onLinkClick(); } }, { children: "Acessar Link" }), void 0) }, void 0))] }), void 0) }, void 0));
};
